const Leaves = ({ leaves, shouldShowLeaf, getLeafTooltip, isDynamic = false, parentDirection = null }) => {
  return (
    <>
      {leaves.map((leafNum, index) => {
        if (!shouldShowLeaf(leafNum)) {
          return null;
        }

        const leafClass = isDynamic ? `leaf${index + 1}` : `leaf${leafNum}`;

        return (
          <div
            key={`l${leafNum}`}
            id={`l${leafNum}`}
            className={`leaf ${leafClass}`}
            title={getLeafTooltip ? getLeafTooltip(leafNum) : ''}
            style={{ display: 'block' }}
            aria-hidden="true"
          />
        );
      })}
    </>
  );
};

export default Leaves;
